import { Outlet, useLocation } from 'react-router';
import Navbar from '@acorn-portal/shared/src/components/navbar/UnauthorisedNavBar';
import Footer from '@acorn-portal/shared/src/components/footer';
import { styled, Box } from '@mui/material';
import Logo from '@acorn-portal/shared/src/assets/acorn/icons/acorn_logo_white.svg?react';
import { FooterDetails } from '@acorn/portal/src/copy/AcornCopy';
import ScrollToTop from '@acorn-portal/shared/src/components/ScrollToTop';

const Main = styled('main')({
	display: 'flex',
	flexDirection: 'column',
	height: '100%',
});

const UnauthorizedLayout = () => {
	const location = useLocation();
	return (
		<Main>
			<ScrollToTop />
			<Navbar Logo={Logo} />
			<Box sx={{ flexGrow: 1, width: '100%' }}>
				<Box
					sx={(theme) => ({
						display: 'grid',
						gridTemplateColumns: `1fr ${theme.breakpoints.values.lg}px 1fr`,
						pb: '1rem',
						[theme.breakpoints.down('md')]: {
							display: 'flex',
							flexDirection: 'column',
							pb: 'unset',
						},
					})}
				>
					<Box />
					<Box key={location.pathname}>
						<Outlet />
					</Box>
				</Box>
			</Box>
			<Footer footerDetails={FooterDetails} />
		</Main>
	);
};

export default UnauthorizedLayout;
